
import { observer } from 'mobx-react-lite'
import { useEffect } from 'react'

// evertel
import { DrawerNavItemLink } from '../elements'
import { useService } from '@evertel/di'
import { CurrentUserController } from '@evertel/blue-user'
import { Icon } from '@evertel/web/ui'
import { SessionService } from '@evertel/session/SessionService'
import { DepartmentController } from '@evertel/department'


const ManageDrawer: React.FC = observer(() => {
    const currentUserController = useService(CurrentUserController, [])
    const sessionService = useService(SessionService, [])
    const departmentController = useService(DepartmentController, [])

    useEffect(() => {
        if (sessionService.selectedDepartmentId) {
            departmentController.init(sessionService.selectedDepartmentId as number)
        }
    }, [sessionService.selectedDepartmentId])


    return (
        <>
            <h3 className="ms-0 mb-3" style={{ color: '#DDD' }}>
                <Icon name="people-roof" size={20} className="me-3" />
                Manage Agency
            </h3>
            <DrawerNavItemLink
                label="Users"
                icon={{ name: 'users' }}
                to="/manage/users"
                selectedTo="/manage/user"
            />
            <DrawerNavItemLink
                label="Rooms"
                icon={{ name: 'sitemap' }}
                to="/manage/rooms"
            />
            {currentUserController.canExecutive && (
                <>
                    <DrawerNavItemLink
                        label="Audits"
                        icon={{ name: 'search' }}
                        to="/manage/audits"
                    />
                    <DrawerNavItemLink
                        label="History Logs"
                        icon={{ name: 'history' }}
                        to="/manage/history"
                    />
                    <DrawerNavItemLink
                        label="Usage Reports"
                        icon={{ name: 'chart-pie' }}
                        to="/manage/reports"
                    />
                    <DrawerNavItemLink
                        label="Agency Settings"
                        icon={{ name: 'cogs' }}
                        to="/manage/agency/settings"
                    />
                    {departmentController.integrationsEnabled && (
                        <DrawerNavItemLink
                            label="Connector Configuration"
                            icon={{ name: 'share-nodes' }}
                            to={`/manage/connectors`}
                            selectedTo={`/manage/connectors`}
                        />
                    )}
                </>
            )}
        </>
    )
})

export { ManageDrawer }
